import passport_icon from '../../../images/passport_icon.png';
import Subtract from '../../../images/Subtract.png';
import globe_plane from '../../../images/globe_plane.png';
import { Typography, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function Visa() {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm')); // true for mobile/tablet

  return (
    <div>
      <div style={{ padding: matches ? 24 : 48 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            marginTop: 16,
            flexDirection: matches ? 'column' : 'row', // Stack elements on smaller screens
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignSelf:matches?'':'self-start',
              width: 40,
              height: 40,
              backgroundColor: '#D9D9D9',
              borderRadius: '50%',
            }}
          >
            <Avatar
              src={passport_icon}
              alt="Student Graduation Icon"
              sx={{alignSelf:'center',width: 24, height: 24, backgroundColor: 'transparent' }}
            />
          </div>

          <Typography
            width={matches ? '90%' : '70%'} // Adjust width for smaller screens
            fontFamily="Montserrat"
            fontWeight="700"
            marginTop="5px"
            fontSize={matches ? '18px' : '24px'} // Smaller font size on mobile
            lineHeight="32px"
            textAlign="center"
            color="#12121299"
          >
            Passport Completion: Students will get two months from the date of selection to complete their passport application process.
          </Typography>
        </div>
      </div>

      <div
        style={{
          backgroundImage: `url(${Subtract})`,
          backgroundSize: 'cover',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundRepeat: 'no-repeat',
          padding: 20,
          backgroundPosition: 'center',
          width: '100%',
          height: matches ? '250px' : '350px', // Adjust height for mobile view
        }}
      >
        <Typography
          width={matches ? '90%' : '45%'} // Adjust width for smaller screens
          marginTop={matches ? '15%' : '5%'}
          marginLeft='5%'
          fontFamily="Montserrat"
          fontWeight="500"
          fontSize={matches ? '18px' : '24px'} // Smaller font size on mobile
          lineHeight="32px"
          textAlign="center"
          color="#FFFFFF"
        >
          Among the selected students from Simplifying Skills, only those who clear the visa interview will be eligible for further travel
        </Typography>

        {/* Conditionally render the image on larger screens */}
        {!matches && (
          <div>
            <img src={globe_plane} style={{ width: 'auto' }} />
          </div>
        )}
      </div>
    </div>
  );
}
